import { render, staticRenderFns } from "./RDL.vue?vue&type=template&id=442f82b4&"
import script from "./RDL.vue?vue&type=script&lang=ts&"
export * from "./RDL.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports